import { render, staticRenderFns } from "./EventTabs.vue?vue&type=template&id=0998aa7b&scoped=true"
import script from "./EventTabs.vue?vue&type=script&lang=js"
export * from "./EventTabs.vue?vue&type=script&lang=js"
import style0 from "./EventTabs.vue?vue&type=style&index=0&id=0998aa7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998aa7b",
  null
  
)

export default component.exports